import production from './production';

export default {
  ...production,
  IMAGE_CDN_DOMAIN: process.env.IMAGE_CDN_DOMAIN || 'https://teja8.kuikr.com'
};
